import { useEffect } from 'react';

function Home() {
  useEffect(() => {
    window.open('https://www.urbanpiper.com/', '_self');
  }, []);

  return null;
}

export default Home;
